// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"34a46f8f","455":"e45d7150","977":"5b403a8f"}[chunkId] + ".chunk.js";
};